import * as React from "react";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";

const SelectProjectsAutocomplete = ({
    projectNames,
    projectsToSetup,
    setProjectsToSetup,
    projects,
}) => {
    if (!projects || !projectNames) return null;

    const handleProjectsChange = (event, newValue) => {
        const projectsMap = new Map(projectsToSetup.map((proj) => [proj.name, proj]));
        const updatedProjects = newValue
            .map((name) => {
                const project = projects.find((proj) => proj.name === name);
                if (project) {
                    const existingProject = projectsMap.get(name);
                    return {
                        name,
                        fields: existingProject ? existingProject.fields : {},
                        id: project.id,
                    };
                }
                return null;
            })
            .filter(Boolean);

        setProjectsToSetup(updatedProjects);
    };

    return (
        <Stack spacing={3} style={{ width: "100%" }}>
            <Autocomplete
                multiple
                id="tags-outlined"
                options={projectNames}
                onChange={handleProjectsChange}
                getOptionLabel={(option) => option}
                defaultValue={projectNames[0]}
                filterSelectedOptions
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label="Select projects"
                        placeholder="Selected projects"
                        sx={{ fontSize: 12 }}
                    />
                )}
            />
        </Stack>
    );
};

export default SelectProjectsAutocomplete;
